import { Database } from "../../constants/schema.js";
//#region src/utils/schema-aml-parser/dataType.ts
var stringTypes = {
	[Database.MariaDB]: "VARCHAR(255)",
	[Database.MSSQL]: "varchar(255)",
	[Database.MySQL]: "VARCHAR(255)",
	[Database.Oracle]: "VARCHAR2(255)",
	[Database.PostgreSQL]: "varchar(255)",
	[Database.SQLite]: "TEXT",
	[Database.Databricks]: "STRING",
	[Database.Snowflake]: "VARCHAR(255)"
};
function resolveDataType(typeName, database, model, enumValues = []) {
	const resolved = resolveType(typeName, model, enumValues);
	if (!resolved.members) return resolved.typeName;
	return enumDataType(resolved.members, database) ?? stringTypes[database] ?? resolved.typeName;
}
function enumCommentSuffix(typeName, model, database, enumValues = []) {
	const { members } = resolveType(typeName, model, enumValues);
	if (!members || enumDataType(members, database) !== void 0) return "";
	return ` ${typeName}: ${members.join(" | ")}`;
}
function enumDataType(members, database) {
	if (database !== Database.MySQL && database !== Database.MariaDB) return;
	return `ENUM(${members.map((member) => `'${member.replace(/'/g, "''")}'`).join(",")})`;
}
function resolveType(typeName, model, enumValues) {
	if (enumValues.length) return {
		typeName,
		members: enumValues
	};
	const seen = /* @__PURE__ */ new Set();
	let current = typeName;
	while (!seen.has(current)) {
		seen.add(current);
		const type = getType(current, model);
		if (!type) break;
		if (type.values.length) return {
			typeName: current,
			members: type.values
		};
		if (!type.alias) break;
		current = type.alias;
	}
	return {
		typeName: current,
		members: null
	};
}
function getType(typeName, model) {
	const type = model.types[typeName];
	if (type) return type;
	const qualified = Object.keys(model.types).find((name) => name.slice(name.lastIndexOf(".") + 1) === typeName);
	return qualified === void 0 ? void 0 : model.types[qualified];
}
//#endregion
export { enumCommentSuffix, resolveDataType };
